import React, { useEffect } from "react";

export default function Filter({ kategory, filters, changeUserFilters }) {
  const [value, setValue] = React.useState('')

  const options = filters.map(item => {
    return <option key={`id${item.id}`} value={item.id}>{item.name}</option>
  })

  useEffect(() => {
    if(value !== kategory) {
      changeUserFilters(value)
      setValue(kategory)
    }
  },[value])

  function changeHandler(e) {
    setValue(e.target.value)
  }

  return (
    <div className="test-creator-settings-element">
        <select name={kategory} value={kategory} onChange={(e) => changeHandler(e)} >
          <option value=''>{kategory}</option>
          {options}
        </select>    
    </div>
  )
}